import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1681c30a&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=1681c30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1681c30a",
  null
  
)

export default component.exports